{
  "title": "等级说明",
  "label": "VIP",
  "levelLabel": "VIP {{level}}",
  "levelChangeConditions": "等级变动条件",
  "levelChangeHint": "达成「升级条件 A 或 B」，即可升级！若未达到「维持等级条件 A 或 B」，将于下一期降级。",
  "compareBenefits": "比较等级权益",
  "vipLevel": "VIP等级",
  "sellOrderLevelCondition": "卖单等级条件",
  "or": "或",
  "exchangeLevelCondition": "闪兑等级条件（{{token}}）",
  "maintainNext": "下一期维持 V{{level}}",
  "promote": "晋升 V{{level}}",
  "demoteNext": "下一期降至 V{{level}}",
  "maintain": "维持 V{{level}}",
  "maintainLevel": "维持等级",
  "upgrade": "升级",
  "conditionA": "{{action}}条件 A",
  "conditionB": "{{action}}条件 B",
  "currentPeriodSellOrderCount": "本期卖单笔数",
  "currentPeriodSellOrderCountTarget": "本期卖单笔数达",
  "currentPeriodSellOrderAmount": "本期卖单数量（{{token}}）",
  "currentPeriodSellOrderAmountTarget": "本期卖单数量（{{token}}）达",
  "currentPeriodExchangeAmount": "本期闪兑数量（{{token}}）",
  "currentPeriodExchangeAmountTarget": "本期闪兑数量（{{token}}）达",
  "countOnly": "达{{count}}笔",
  "amountOnly": "金额达 {{amount}}",
  "countAndAmount": "达{{count}}笔\n且数量达 {{amount}} {{token}}"
}
